import * as React from 'react'
import TimelineList from 'components/TimelineList'
import TimelineListItem from 'components/TimelineList/TimelineListItem'
import { moment } from 'features/Moment'
import { orderBy } from 'lodash'

export interface IContactFlowsTimelineProps {
  flowLogs: {
    id: string
    created: string
    flowId: string
    flow?: {
      name?: string
    }
  }[]
}

export class ContactFlowsTimeline extends React.Component<IContactFlowsTimelineProps> {
  render() {
    const { flowLogs } = this.props
    return (
      <TimelineList title="Recent Flow logs">
        {flowLogs &&
          orderBy(flowLogs, ['created'], ['desc'])
            .slice(0, 25)
            .map((item, idx) => {
              return (
                <TimelineListItem key={idx} to={`/dashboard/flows/${item.flowId}/logs/${item.id}`}>
                  {(item.flow && item.flow.name) || 'Unknown Flow'} -{' '}
                  {moment(item.created).fromNow()}
                </TimelineListItem>
              )
            })}
        {(!flowLogs || flowLogs.length === 0) && (
          <TimelineListItem>No flows have been triggered.</TimelineListItem>
        )}
      </TimelineList>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Contacts/ContactFlowsTimeline/ContactFlowsTimeline.tsx